import assignToThis from '../../../helper/assignToThis';

export class ScenarioRevenue {
  
  public contractType: string | null = null;
  public caseType: string | null = null;
  public ppa1Duration: number | null = null;
  public ppa1RateInflationIndex: number | null = null;
  public ppa1ProductionSold: number | null = null;
  public leaseDuration: number | null = null;
  public selfConsumptionPlantRent: number | null = null;
  public leaseInflation: number | null = null;
  public activePrePPA: string | null = 'COMEX continued';
  public activePostPPA: string | null = 'COMEX continued';
  public saleCapacityCertificate: boolean | null = false;
  public marketCapacityPrice: string | null = 'Scénario interne';
  public merchantPeriodGuarantee: boolean | null = true;
  public amountOfOrigin: number | null = 2;

  public constructor(obj: object = {}) {
    assignToThis(this, obj);
  }

}
